import { Controller } from "stimulus";

export default class extends Controller {
  async initialize() {
    this.sitesFormSaveUrl = document.location.origin + this.data.get("sitesSubmitPath") + ".json";
    this.sitesApiUrl      = this.data.get("sitesApiUrl");
    this.clientId         = this.data.get("clientId");
    this.clientSecret     = this.data.get("clientSecret");
  }

  importSites(event, skip = 0, take = 50, count = 1, start = 0) {
    if (start == 0 || skip < count) {
      this.getSites(skip, take, start);
      return;
    }
    window.location.reload();
  }

  getSites(skip, take, start) {
    // query string
    let params = {
      "skip": skip,
      "take": take
    };
    
    let query = Object.keys(params)
                 .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
                 .join('&');
    // send request
    fetch(this.sitesApiUrl+ "?" + query, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Client-Id": this.clientId,
        "Client-Secret": this.clientSecret,
      },
      method: "GET",
    })
      .then((response) => response.json())
      .then((result) => {
        this.pushSites(result.data, skip, take, start);
      });
  }

  pushSites(responseData, skip, take, start) {
    // send request
    fetch(this.sitesFormSaveUrl, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-CSRF-Token": document.head
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      method: "POST",
      body: JSON.stringify({
        import_data: {
          sites: responseData.data,
        },
      }),
    }).then((response) => {
      skip = take;
      take = take + 50;
      start = start + 1;
      var count = responseData.count;
      this.importSites("", skip, take, count, start);
    });
  }
}
